module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_map_x32-37c16.png";